/**
 * A client portal subdomain is one DNS label: alphanumeric at each end,
 * hyphens allowed in between, 3 to 63 characters.
 *
 * Lowercase only. DNS is case-insensitive, so allowing upper case would let
 * `Acme` and `acme` both be claimed while resolving to the same host, and would
 * let `Admin` slip past the reserved-name list.
 */
export const CLIENT_PORTAL_SUBDOMAIN_PATTERN =
  /^[a-z0-9][a-z0-9-]{1,61}[a-z0-9]$/;

export const CLIENT_PORTAL_SUBDOMAIN_FORMAT_MESSAGE =
  'Must be at least 3 characters. Only lowercase letters, numbers and intermediate hyphens are allowed';

export const isValidClientPortalSubdomain = (subdomain: string): boolean =>
  CLIENT_PORTAL_SUBDOMAIN_PATTERN.test(subdomain);
